import { BookingActivity } from '../models/booking/ActivitiesResponse';

export const formatLocation = (value: string): string =>
  value.replace(/([A-Z])/g, ' $1').trim();

// Human-readable activity duration. Sub-hour durations read as minutes
// (e.g. 0.5 → "30 minutes") rather than fractional hours.
export const formatActivityDuration = (durationInHours: number): string => {
  if (durationInHours < 1) {
    const minutes = Math.round(durationInHours * 60);
    return `${minutes} minute${minutes === 1 ? '' : 's'}`;
  }
  return `${durationInHours} hour${durationInHours === 1 ? '' : 's'}`;
};

export const formatUsTime = (slot: string): string => {
  const [hours, minutes] = slot.split(':').slice(0, 2).map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
};

export const getSelectedActivityDurationHours = (
  activities: BookingActivity[],
  activityId: string | null
): number => {
  if (!activityId) {
    return 0;
  }

  const selected = activities.find((activity) => activity.id === activityId);
  return selected?.durationInHours ?? 0;
};

export const getSelectedActivityCreditCost = (
  activities: BookingActivity[],
  activityId: string | null
): number => {
  if (!activityId) return 0;
  const selected = activities.find((activity) => activity.id === activityId);
  return selected?.creditCost ?? 0;
};

export const calculateRequiredCredits = (
  activities: BookingActivity[],
  activityId: string | null,
  fullMotion: number,
  esports: number
): number => {
  const perSeat = getSelectedActivityCreditCost(activities, activityId);
  return perSeat * (fullMotion + esports);
};
